<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header">
              New Customer
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-12">
                  <h3>Customer Name &amp; Account Details</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="name">Name:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    name="name"
                    ref="customer_name"
                    placeholder="name"
                    v-model="name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="account">Account #:</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="account"
                    name="account"
                    ref="customer_account"
                    placeholder="account"
                    v-model="account"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Billing Address</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address1">Address 1:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address1"
                    ref="customer_address1"
                    name="address1"
                    placeholder=""
                    v-model="address1"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address2">Address 2:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address2"
                    ref="customer_address2"
                    name="address2"
                    placeholder=""
                    v-model="address2"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address3">Address 3:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address3"
                    ref="customer_address3"
                    name="address3"
                    placeholder=""
                    v-model="address3"
                  />
                </div>
              </div>
              <div class="row">
                <div class=" col-2">
                  <label for="city">City:</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="city"
                    ref="customer_city"
                    name="city"
                    placeholder="city"
                    v-model="address_city"
                  />
                </div>
                <div class=" col-1">
                  <label for="state">State:</label>
                </div>
                <div class="col-1 no-padding">
                  <input
                    type="text"
                    class="form-control"
                    id="state"
                    ref="customer_state"
                    name="state"
                    placeholder="state"
                    v-model="address_state"
                  />
                </div>
                <div class=" col-2">
                  <label for="postcode">Postcode:</label>
                </div>
                <div class="col-1 no-padding">
                  <input
                    type="text"
                    class="form-control"
                    id="postcode"
                    ref="customer_postcode"
                    name="postcode"
                    placeholder="0000"
                    v-model="address_postcode"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Contact Details</h3>
                </div>
              </div>
              <div class="row">
                <div class=" col-2">
                  <label for="phone">Phone:</label>
                </div>
                <div class="col-3">
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    ref="customer_phone"
                    name="phone"
                    placeholder="phone"
                    v-model="phone"
                  />
                </div>
                <div class=" col-2">
                  <label for="fax">Fax:</label>
                </div>
                <div class="col-3">
                  <input
                    type="text"
                    class="form-control"
                    id="fax"
                    ref="customer_fax"
                    name="fax"
                    placeholder="fax"
                    v-model="fax"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="email">Email:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    ref="customer_email"
                    name="email"
                    placeholder="email"
                    v-model="email"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="contact">Contact:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="contact"
                    ref="customer_contact"
                    name="contact"
                    placeholder="contact"
                    v-model="contact"
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewCustomerModal",
  props: {},
  data: () => ({
    name: "",
    account: "",
    address1: "",
    address2: "",
    address3: "",
    address_city: "",
    address_state: "",
    address_postcode: "",
    email: "",
    phone: "",
    fax: "",
    contact: "",
  }),
  methods: {
    ...mapActions("customers", ["apiCreateCustomer"]),
    _save() {
      if (!this.$refs.customer_name.value) {
        alert("please enter a name");
        return;
      }
      var customer = {
        id: 0,
        name: this.$refs.customer_name.value,
        account_number: this.$refs.customer_account.value,
        address: {
          id: 0,
          address1: this.$refs.customer_address1.value,
          address2: this.$refs.customer_address2.value,
          address3: this.$refs.customer_address3.value,
          city: this.$refs.customer_city.value,
          state: this.$refs.customer_state.value,
          postcode: this.$refs.customer_postcode.value,
        },
        phone: this.$refs.customer_phone.value,
        fax: this.$refs.customer_fax.value,
        email: this.$refs.customer_email.value,
        contact: this.$refs.customer_contact.value,
        active: true,
      };
      this.apiCreateCustomer(customer);
      this.$emit("close");
    },
    clear() {
      this.name = "";
      this.description = "";
    },
  },
  components: {},
};
</script>
